import React from 'react';
import { withStyles } from '@material-ui/core';
import { Stack } from '@mui/material';
import VTypography from '../../Venti-UI-Kit/VTypography/VTypography';
import VIconButton from '../../Venti-UI-Kit/Buttons/VIconButton';
import styles from './styles';

const OrganizerCard = ({ organizer, onRemove, classes }) => {
  const handleRemove = () => {
    if (onRemove && organizer.id) {
      onRemove(organizer.id);
    }
  };

  return (
    <div className={classes.cardContainer}>
      {onRemove && (
        <VIconButton
          icon="cross-large"
          onClick={handleRemove}
          color="noColor"
          size="small"
          className={classes.removeButton}
        />
      )}
      <div className={classes.avatarContainer}>
        {organizer.logoImg ? (
          <img src={organizer.logoImg} alt={organizer.name} className={classes.avatarImage} />
        ) : (
          <VTypography variant="h6">{organizer.name?.charAt(0)?.toUpperCase()}</VTypography>
        )}
      </div>
      <Stack direction="column">
        <VTypography variant="body1" fontWeight={600}>
          {organizer.name}
        </VTypography>
      </Stack>
    </div>
  );
};

export default withStyles(styles)(OrganizerCard);
